// ============================================================
// ModalPacienteIncompleto
// ------------------------------------------------------------
// Modal bloqueante que se muestra cuando NOM-024 está activa
// y el paciente no tiene los datos obligatorios completos.
// ============================================================

import React from "react";
import { useNavigate } from "react-router-dom";
import "./ModalEdicion.css";
import { normalizarCURP, esCurpExtranjero } from "../../../../utils/validaciones/identidad";

const CAMPOS_NOM024_PACIENTE = [
  { key: "curp", label: "CURP del paciente" },
  { key: "nombre", label: "Nombre" },
  { key: "apellido_paterno", label: "Primer apellido" },
  { key: "apellido_materno", label: "Segundo apellido" },
  { key: "fecha_nacimiento", label: "Fecha de nacimiento" },
  { key: "paisNacPaciente", label: "País de nacimiento" },
  { key: "entidadNacimiento", label: "Entidad de nacimiento" },
  { key: "paisResidencia", label: "País de residencia" },
  { key: "entidadResidencia", label: "Entidad de residencia" },
  { key: "municipio", label: "Municipio de residencia" },
  { key: "localidad", label: "Localidad de residencia" },
  { key: "sexoCURP", label: "Sexo registrado ante RENAPO" },
  { key: "sexo", label: "Sexo biológico" },
  { key: "genero", label: "Género" },
  { key: "derechohabiencia", label: "Derechohabiencia" },
];

export function obtenerFaltantesPacienteNOM024(paciente, curpPrestador) {
  if (!paciente) return CAMPOS_NOM024_PACIENTE.map((c) => c.label);

  const faltantesBase = CAMPOS_NOM024_PACIENTE
    .filter((campo) => {
      const valor = paciente[campo.key];
      return valor === undefined || valor === null || String(valor).trim() === "";
    })
    .map((campo) => campo.label);

const faltantesCondicionales = [];

const migrante = paciente?.migrante;
const paisProcedencia = paciente?.paisProcedencia;

if (Number(migrante) === 2) {
  const paisProcedenciaVacio =
    paisProcedencia === undefined ||
    paisProcedencia === null ||
    String(paisProcedencia).trim() === "";

  if (paisProcedenciaVacio) {
    faltantesCondicionales.push(
      "Selecciona el país de procedencia del paciente migrante internacional."
    );
  }
}

const curpPaciente = normalizarCURP(paciente?.curp || "");
const curpMedico = normalizarCURP(curpPrestador || "");

if (
  curpPaciente &&
  curpMedico &&
  curpPaciente.length === 18 &&
  curpMedico.length === 18 &&
  curpPaciente === curpMedico &&
  !esCurpExtranjero(curpPaciente)
) {
  faltantesCondicionales.push(
    "La CURP del paciente no puede ser igual a la CURP del prestador de servicios."
  );
}

return [...faltantesBase, ...faltantesCondicionales];
}

const ModalPacienteIncompleto = ({ faltantes, pacienteId }) => {
  const navigate = useNavigate();

  if (!faltantes || faltantes.length === 0) return null;

  return (
    <div className="modal-overlay modal-perfil-overlay">
      <div className="modal-content modal-perfil">
        <h3>⚠️ Datos del paciente incompletos</h3>
      <h5>Considera que estos datos ya no se podrán mover una vez guardada la primer consulta</h5>
        <p>
          Se deben completar los siguientes datos del paciente antes de
          iniciar la consulta:
        </p>
        <ul className="modal-perfil-lista">
          {faltantes.map((campo, i) => (
            <li key={i}>❌ {campo}</li>
          ))}
        </ul>
        <div className="modal-buttons">
          <button
            className="btn-guardar"
            onClick={() =>
              navigate(`/dashboard/paciente/${pacienteId}?editar=true`)
            }
          >
            Completar datos del paciente
          </button>
          <button
            className="btn-cancelar"
            onClick={() => navigate(-1)}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalPacienteIncompleto;